import { render, staticRenderFns } from "./OrderPermittingPage.vue?vue&type=template&id=74c1b51a&scoped=true&"
import script from "./OrderPermittingPage.vue?vue&type=script&lang=js&"
export * from "./OrderPermittingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c1b51a",
  null
  
)

export default component.exports